import { render, staticRenderFns } from "./ImageCollectionZone.vue?vue&type=template&id=2d2fc0d6&scoped=true&"
import script from "./ImageCollectionZone.vue?vue&type=script&lang=ts&"
export * from "./ImageCollectionZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2fc0d6",
  null
  
)

export default component.exports